import { NotificationRepository } from '../repositories/NotificationRepository';

export class GetUnreadNotificationCountUseCase {
  constructor(private notificationRepository: NotificationRepository) {}

  async execute(userId: string): Promise<number> {
    return await this.notificationRepository.getUnreadCount(userId);
  }
}
